import React from 'react';
import PropTypes from 'prop-types';
import ModalLoader from '../../../layouts/modals/ModalLoader';
import ModalDate from '../../../layouts/modals/ModalDate';
import ModalIdioma from '../../../layouts/modals/ModalIdioma';
import '../../../assets/styles/login/styles.css';
import useCiclo from './hooks/useCiclo';
import CabeceraCiclo from './CabeceraCiclo';
import TablaModulos from './TablaModulos';

function Ciclo(props) {
  const { ciclo, datos, matriculas, documento, balance, recibosPendientes, nombre } = props;
  const hookProps = { ciclo, datos, matriculas, documento, balance, recibosPendientes, nombre };
  const {
    userOU,
    limpio,
    tooltipBalance,
    toggleTooltipBalance,
    isLoading,
    collapse,
    isToolTipHoursOpened,
    isToolTipResultOpened,
    modalDate,
    setModalDate,
    modalIdioma,
    setModalIdioma,
    defaultIdiomaCertificado,
    setFecha,
    setFechaFinal,
    fecha,
    fechaFinal,
    notaCiclo,
    toggle,
    toggleHours,
    toggleResult,
    download,
    downloadFile,
    descargarCercomConIdioma,
    handleCalculateNote,
  } = useCiclo(hookProps);

  return (
    <>
      {modalDate ? (
        <ModalDate
          state={modalDate}
          dateFunction={download}
          setState={setModalDate}
          setFecha={setFecha}
          setFechaFinal={setFechaFinal}
          fecha={fecha}
          fechaFinal={fechaFinal}
        />
      ) : null}
      {modalIdioma ? (
        <ModalIdioma
          isOpen={modalIdioma}
          defaultIdiomaId={defaultIdiomaCertificado}
          header="¿En qué idioma quieres el certificado?"
          onConfirm={descargarCercomConIdioma}
          onCancel={() => setModalIdioma(false)}
        />
      ) : null}
      {isLoading ? <ModalLoader header="Generando documento" /> : null}
      <div className="mb-3">
        <CabeceraCiclo
          limpio={limpio}
          horas={ciclo.horas}
          notaCiclo={notaCiclo}
          userOU={userOU}
          documento={documento}
          recibosPendientes={recibosPendientes}
          balance={balance}
          tooltipBalance={tooltipBalance}
          isToolTipHoursOpened={isToolTipHoursOpened}
          isToolTipResultOpened={isToolTipResultOpened}
          onToggle={toggle}
          onToggleHours={toggleHours}
          onToggleResult={toggleResult}
          onToggleTooltipBalance={toggleTooltipBalance}
          onCalculateNote={handleCalculateNote}
          onDownloadFile={downloadFile}
        />
        <TablaModulos isOpen={collapse} modulos={ciclo.modulos || []} />
      </div>
    </>
  );
}

Ciclo.propTypes = {
  recibosPendientes: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  ciclo: PropTypes.shape({
    nota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    horas: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    codigo: PropTypes.string,
    codigo2: PropTypes.string,
    nombre: PropTypes.string,
    modulos: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  datos: PropTypes.object.isRequired,
  matriculas: PropTypes.arrayOf(PropTypes.object),
  balance: PropTypes.number.isRequired,
  documento: PropTypes.arrayOf(
    PropTypes.shape({ codigo: PropTypes.string, nombre: PropTypes.string }),
  ).isRequired,
  nombre: PropTypes.string.isRequired,
};

export default Ciclo;
